export default __webpack_public_path__ + "static/media/0.d1474868.png";